import { useLocation } from "react-router-dom";
import Header from "../components/common/header&footer/Header";
import Footer from "../components/common/header&footer/Footer";
import FeatureSection from "../components/common/FeatureSection";
import FeaturedProducts from "../components/common/FeaturedProducts";
import TopSellerCarousel from "../components/common/TopSellerCarousel";
import BestSellerSection from "../components/common/BestSellerCarousel";
import LatestNews from "../components/common/blog/LatestNews";
import Sidebar from "../components/common/Sidebar";

export default function MainLayout({ children }) {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <>
      <Header />
      <main>{children}</main>

      {isHomePage && (
        <>
          <FeatureSection />
          <FeaturedProducts />
          {/* <TopSellerCarousel />  */}
          <BestSellerSection />
          {/* <LatestNews /> */}
        </>
      )}

      <Footer />
    </>
  );
}
